import { defaultTheme } from 'sletat-ui-components2/dist/theme';

const { theme } = defaultTheme;

export const styles = {
    '@keyframes riseWidth': {
        from: { width: 0},
        to: { width: '100%'},
    },
    container: {
        position: 'relative',
        width: '100%',
        borderRadius: 3,
    },
    containerS: {
        height: 3,
        backgroundColor: theme.colorVariables.bgPrimary,
    },
    containerL: {
        height: 6,
        backgroundColor: theme.colorVariables.bgFieldDisabled,
    },
    rating: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        borderRadius: 3,
        animationDelay: '0.2s',
        animation: 'riseWidth 0.5s',
        animationFillMode: 'forwards',
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
